import { render, staticRenderFns } from "./TableDivCustom.vue?vue&type=template&id=2bfce222&scoped=true&"
import script from "./TableDivCustom.vue?vue&type=script&lang=js&"
export * from "./TableDivCustom.vue?vue&type=script&lang=js&"
import style0 from "./TableDivCustom.vue?vue&type=style&index=0&id=2bfce222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfce222",
  null
  
)

export default component.exports